export function WhiteSpace({height=0,width=0}){
    return (
        <div style={{height,width}}/>
    )
}